import React, { useState, useEffect } from "react";
import CustomNavbar from "../../../components/CustomNavbar";
import { useSelector, useDispatch } from "react-redux";
import SidebarDashboard from "../../../components/evaluacion_desempenio/SidebarEvaluacionDesempenio";
import {
  Alert,
  Button,
  ButtonGroup,
  Card,
  Container,
  Row,
  Col,
  Form,
  Modal,
  Spinner,
  Tooltip,
  OverlayTrigger,
  Dropdown,
} from "react-bootstrap";

import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";
import toastr from "toastr";

//Tabla, Navbar y Sidebar
import CustomPagint from "../../../components/CustomPagint";
import messages from "../../../redux/messages";
import CustomTableBackendFilters from "../../../components/CustomTableBackendFilters";

//redux
import { Typeahead } from "react-bootstrap-typeahead";
import { getConfSmart } from "../../../redux/evaluacion_desempenio/ConfSmart/actions";
import { deleteObjectiveValuePillar, editObjectiveValuePillar, getObjectiveValuePillar, resetObjectiveValuePillar, saveObjectiveValuePillar } from "../../../redux/evaluacion_desempenio/ObjectiveValuePillar/actions";





const ObjectiveValuePillar = (props) => {
  const [show, setShow] = useState(true);
  const onShowSidebar = () => setShow(show ? false : true);

  //Variables para filtrado y paginación
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState({});

  //Variables para editar
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [anio, setAnio] = useState("");
  const [selectedConf, setSelectedConf] = useState(null);

  const yearsOptions = Array.from(
    { length: 5 },
    (_, i) => ({
      id: moment().year() - i,
      label: moment().year() - i
    })
  );

  //Variables para el formulario
  const [showFormModal, setShowFormModal] = useState(false);
  const [validated, setValidated] = useState(false);


  //Redux
  const dispatch = useDispatch();
  const objectiveValuePillarStore = useSelector(
    (store) => store.objectiveValuePillar
  );


  const {
    loading,
    objectiveValuePillars,
    objectiveValuePillarsLength,
    objectiveValuePillarError,
    saveLoading,
    formError,
  } = objectiveValuePillarStore;

  const {
    loading: loadingConfSmart,
    confSmartsLength,
    confSmarts,
    confSmartError
  } = useSelector((store) => store.confSmart);


  //Esquema de validación
  const schema = Yup.object().shape({
    nombre: Yup.string().ensure().required("**Campo requerido"),
    descripcion: Yup.string().ensure().required("**Campo requerido"),
    peso: Yup.number().typeError("**Debe ser un número").required("**Campo requerido").min(0, "**Debe ser mayor o igual a 0").max(100, "**Debe ser menor o igual a 100")
      .test(
        "weight-sum",
        "**La suma de los pesos no puede exceder 100",
        function (value) {
          const newPeso = Number(value || 0);
          const sumExisting = (objectiveValuePillars || []).reduce((acc, it) => acc + Number(it.peso || 0), 0);
          const previousPeso = edit ? Number(editItem?.peso || 0) : 0;
          const total = sumExisting - previousPeso + newPeso;
          return total <= 100;
        }
      ),
      desempeno_esperado: Yup.number().typeError("**Debe ser un número").min(0, "**Debe ser mayor o igual a 0").max(100, "**Debe ser menor o igual a 100").required("**Campo requerido"),
      
  });

  useEffect(() => {
    dispatch(resetObjectiveValuePillar())
  }, [])

  useEffect(() => {
    if (anio && selectedConf) {
      dispatch(getObjectiveValuePillar({
        ...filters
      }));
    }
  }, [filters]);


  useEffect(() => {
    if (selectedConf) {
      setFilters({
        ...filters,
        configuracion: selectedConf.id,
      });
    }
  }, [selectedConf])


  useEffect(() => {
    if (anio) {
      dispatch(getConfSmart({
        anio: anio
      }))

    }
  }, [anio])

  const configOptions = confSmarts?.map((level) => ({
    id: level.id,
    label: level.nombre
  })) || [];

  const pages = Math.ceil(
    objectiveValuePillars ? objectiveValuePillarsLength / limit : 0
  );

  const columns = [
    {
      Header: "Nombre",
      accessor: "nombre"

    },

    {
      Header: "Descripción",
      accessor: "descripcion"
    },
    {
      Header: "Peso",
      accessor: "peso"
    },
    {
      Header: "Desempeño Esperado",
      accessor: "desempeno_esperado"
    },
    {
      Header: "Fecha de creación",
      accessor: "fecha_creacion",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="button-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() => onDelete(value.row.original.id, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
          <Button
            size="sm"
            className="text-warning"
            variant="link"
            type="button"
            onClick={() => goToQuestions(value.row.original)}
          >
            <i className="material-icons">quiz</i>
          </Button>
        </div>
      ),
    },
  ];

  //Funciones
  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowFormModal(true);
    setValidated(false);
  };

  const onDelete = (id, data) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteObjectiveValuePillar(id, data));
    }
  };


  const onAdd = () => {
    setShowFormModal(true);
    setEdit(false);
    setValidated(false);
  };



  const handleFiltersChange = (newFilters) => {
    setFilters(newFilters);
    setOffset(0);
  };

  const _getObjectiveValues = (offs = offset, lim = limit) => {
    setOffset(offs);
    setLimit(lim);
  };

  const onSubmit = (req) => {
    req.configuracion = selectedConf.id;
    if (!edit) {
      dispatch(saveObjectiveValuePillar(req, setShowFormModal));
    } else {
      dispatch(editObjectiveValuePillar(req, editItem.id, index, setShowFormModal));
    }
  };

  const goToQuestions = (item) => {
    props.history.push(`/evaluacion-desempenio/admin/objetivos-valores-preguntas/${item.id}/${item.configuracion}`);
  }

  const totalWeight = objectiveValuePillars.reduce((acc, it) => acc + Number(it.peso || 0), 0) || 0;

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h5 className="text-black-50 m-0 text-uppercase">
              VALORES POR OBJETIVOS
            </h5>
            <Form>
              <Form.Row className="justify-content-sm-end align-items-center flex-wrap">
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill"
                      onClick={() => onAdd()}
                      disabled={!selectedConf || loading}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                  </ButtonGroup>
                </Col>
              </Form.Row>
            </Form>
          </div>
          {!!objectiveValuePillarError && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {objectiveValuePillarError}
            </Alert>
          )}

          <div>
            <Form>
              <Form.Row className="">
                <Form.Group as={Col} sm={12} md={6} lg={6} className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Año
                  </Form.Label>
                  <Form.Control
                    as="select"
                    name="anio"
                    className="col rounded-pill"
                    placeholder="Año"
                    value={anio}
                    onChange={(e) => {
                      setSelectedConf(null);
                      setFilters({});
                      setAnio(e.target.value)
                      dispatch(resetObjectiveValuePillar());
                    }}
                  >
                    <option value="">Seleccione un año</option>
                    {yearsOptions.map((year) => (
                      <option key={year.id} value={year.id}>
                        {year.label}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
                <Form.Group as={Col} sm={12} md={6} lg={6} className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Configuración
                  </Form.Label>
                  <div className="d-flex align-items-center">
                    <Typeahead
                      className="w-100"
                      key={anio}
                      id="configuración"
                      name="configuración"
                      placeholder="Seleccione una configuración"
                      options={configOptions}
                      disabled={loadingConfSmart || !anio}
                      onChange={(selected) => {
                        setSelectedConf(selected[0]);
                      }}
                      defaultInputValue={selectedConf ? selectedConf.label : ""}
                    >
                    </Typeahead>
                    {loadingConfSmart && (
                      <Spinner
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="ml-2"
                      />
                    )}
                  </div>
                </Form.Group>
              </Form.Row>
            </Form>
          </div>

          {
            selectedConf && objectiveValuePillarsLength > 0 && (
              <Alert variant={totalWeight < 100 ? "danger" : "success"} className="mx-3 my-2">
                <i className="material-icons me-2">{totalWeight < 100 ? "warning" : "check_circle"}</i> La suma de los pesos asignados a los valores es <strong>{totalWeight}%</strong>. {totalWeight < 100 ? "Debe ser igual a 100%." : ""}
              </Alert>
            )
          }

          <Card className="border-0">
            <Card.Body className="px-1 px-sm-2">
              <CustomTableBackendFilters
                columns={columns}
                data={objectiveValuePillars || []}
                isLoadingData={loading}
                onFiltersChange={handleFiltersChange}
                filters={filters}
              />
            </Card.Body>
          </Card>
          <CustomPagint
            limit={limit}
            setLimit={setLimit}
            offset={offset}
            setOffset={setOffset}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            dataLenght={objectiveValuePillarsLength}
            pages={pages}
            pagFunc={_getObjectiveValues}
          />

        </Container>
        {/*Modal editar*/}
        <Modal show={showFormModal} onHide={() => setShowFormModal(false)}>
          <Formik
            validationSchema={schema}
            onSubmit={onSubmit}
            initialValues={{
              nombre: edit ? editItem.nombre : "",
              descripcion: edit ? editItem.descripcion : "",
              peso: edit ? editItem.peso : "",
              desempeno_esperado: edit ? editItem.desempeno_esperado : "",
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              touched,
              errors,
            }) => (
              <Form onSubmit={handleSubmit} noValidate validated={validated}>
                <Modal.Header closeButton>
                  <Modal.Title className="ft-modal-title">
                    {edit
                      ? "Editar Valor"
                      : "Crear Valor"}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {formError &&
                    typeof formError !== "object" ? (
                    <Alert variant="danger" className="mt-4 mb-2">
                      {formError}
                    </Alert>
                  ) : null}
                  <Form.Group as={Col} className="mb-1">
                    <Form.Label column sm="12" md="12">
                      Nombre
                    </Form.Label>
                    <Form.Control
                      name="nombre"
                      className="rounded-pill"
                      required
                      type="text"
                      value={values.nombre}
                      placeholder="Nombre"
                      onBlur={handleBlur("nombre")}
                      onChange={(e) => handleChange(e)}
                      isInvalid={touched.nombre && !!errors.nombre}
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.nombre}
                    </Form.Control.Feedback>
                    {formError &&
                      typeof formError === "object" &&
                      formError.nombre ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {formError.nombre.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Form.Group>

                  <Form.Group as={Col} className="mb-3">
                    <Form.Label column sm="12" md="12">
                      Descripción
                    </Form.Label>
                    <Form.Control
                      name="descripcion"
                      id="descripcion"
                      className="rounded"
                      as="textarea"
                      value={values.descripcion}
                      placeholder="Descripción"
                      onBlur={handleBlur("descripcion")}
                      onChange={(e) => handleChange(e)}
                      isInvalid={touched.descripcion && !!errors.descripcion}
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.descripcion}
                    </Form.Control.Feedback>
                    {formError &&
                      typeof formError === "object" &&
                      formError.descripcion ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {formError.descripcion.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Form.Group>
                  <Form.Group as={Col} className="mb-3">
                    <Form.Label column sm="12" md="12">
                      Peso (%)
                    </Form.Label>
                    <Form.Control
                      name="peso"
                      className="rounded-pill"
                      type="number"
                      value={values.peso}
                      placeholder="Peso"
                      onBlur={handleBlur("peso")}
                      onChange={(e) => handleChange(e)}
                      isInvalid={touched.peso && !!errors.peso}
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.peso}
                    </Form.Control.Feedback>
                    {formError &&
                      typeof formError === "object" &&
                      formError.peso ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {formError.peso.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Form.Group>
                   <Form.Group as={Col} className="mb-3">
                    <Form.Label column sm="12" md="12">
                      Desempeño Esperado
                    </Form.Label>
                    <Form.Control
                      name="desempeno_esperado"
                      className="rounded-pill"
                      type="number"
                      value={values.desempeno_esperado}
                      placeholder="Desempeño Esperado"
                      onBlur={handleBlur("desempeno_esperado")}
                      onChange={(e) => handleChange(e)}
                      isInvalid={touched.desempeno_esperado && !!errors.desempeno_esperado}
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.desempeno_esperado}
                    </Form.Control.Feedback>
                    {formError &&
                      typeof formError === "object" &&
                      formError.desempeno_esperado ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {formError.desempeno_esperado.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    className="rounded-pill"
                    variant="secondary"
                    onClick={() => setShowFormModal(false)}
                  >
                    Cerrar
                  </Button>
                  <Button
                    className="rounded-pill"
                    disabled={saveLoading}
                    variant="primary"
                    type="submit"
                  >
                    {saveLoading && (
                      <Spinner
                        className="mr-2"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    )}
                    Guardar
                  </Button>
                </Modal.Footer>
              </Form>
            )}
          </Formik>
        </Modal>
        {/*Modal*/}
      </div>
    </>
  );
};

export default ObjectiveValuePillar;
